import { UserModel } from '@/models/user';
import AxiosService from '@/services/AxiosService';
import loaderService from '@/modules/shared/services/loaderService'
import { Inject, Service } from 'vue-di-container';

@Service()
export default class UserService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(loaderService) public loaderService!: loaderService;

    public async getUser(): Promise<UserModel | any> {
        try {
            this.loaderService.showLoader();
            const url = 'api/UserInfo';
            const result = await this.axiosService.axiosInstance.get<UserModel>(url);
            this.loaderService.hideLoader();
            return result;
        } catch (exception) {
            return null;
        }
    }
}
